/**
 * Get Single User API Contract
 *
 * GET /v1/users/:user_public_id
 * Retrieve detailed information for a specific user.
 */

import { z } from 'zod'
import { UserWithSchoolsSchema } from '../../schemas/entities/user'

// Re-export the user schema for consumers that need it directly
export { UserWithSchoolsSchema }

/**
 * Request Schema
 */
export const GetSingleUserRequestSchema = z.object({
  userPublicId: z.string().min(1).describe('User unique identifier (CUID)')
})

export type GetSingleUserRequest = z.infer<typeof GetSingleUserRequestSchema>

/**
 * Response Schema
 */
export const GetSingleUserResponseSchema = z.object({
  data: UserWithSchoolsSchema,
  meta: z.object({}).optional(),
  message: z.string()
})

export type GetSingleUserResponse = z.infer<typeof GetSingleUserResponseSchema>
